import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '@scramble/ui';
import { changeUserLocale } from '@/helpers/locale';
import { LayoutNav } from '../../layout/Navigation';
import Logo from '@scramble/design-system/logo/scramble_logo_black.svg';
import l from '../layout.module.scss';

export const LayoutHeader = ({ onBack }) => {
  const { i18n } = useTranslation();
  const onLocaleChange = locale => changeUserLocale(i18n, locale);

  return (
    <div className={l.header}>
      <div className={l.header_container}>
        <div className={l.logo}>
          <img src={Logo} width={112} height={20} alt="logo" />
        </div>
        <LanguageSwitcher currentLocale={i18n.language} onLocaleChange={onLocaleChange} />
        <LayoutNav onBack={onBack} className={l.header_button} />
      </div>
    </div>
  );
};
